/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { RecaptchaRequestDto } from '../../dto/usuario/recaptcha.dto';
import { RecaptchaResponseDto } from '../../dto/auth/recaptcha-response.dto';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private apiUrl = `${environment.apiUrl}/recaptcha`;

  constructor(private http: HttpClient) {}

  verificarTokenRecaptcha(
    request: RecaptchaRequestDto
  ): Observable<RecaptchaResponseDto> {
    return this.http.post<RecaptchaResponseDto>(
      `${this.apiUrl}/verificar`,
      request
    );
  }
}
